const load = () => {
  let siteKey = "6Lf-d90hAAAAANMvuH7MP-5MNi_lsiwcWChzA0Sh"

  let recaptchaScript = document.createElement("script");
  recaptchaScript.setAttribute('id', 'g-recaptcha');
  recaptchaScript.setAttribute(
      "src",
      `https://www.google.com/recaptcha/api.js?render=${siteKey}`
  );
  document.body.append(recaptchaScript);

  recaptchaScript.onload = () => {
      let loadScript = document.createElement("script");
      loadScript.setAttribute('id', 'g-recaptcha-load');
      loadScript.innerHTML = "window.grecaptcha = grecaptcha;";
      document.body.append(loadScript);
  };
}

const unload = () => {
  let loadScript = document.getElementById('g-recaptcha-load');
  if (loadScript) loadScript.remove()
  let recaptchaScript = document.getElementById('g-recaptcha');
  if (recaptchaScript) recaptchaScript.remove()
  let recaptchaBadge = document.querySelector('div>.grecaptcha-badge');
  if (recaptchaBadge) recaptchaBadge.remove()

  delete window.grecaptcha
}

export default { load, unload }
